<template>
  <div v-show="show" class="popup v-fade" @click="$emit('toggleShow')">
    <div class="container popup__flex-box">
      <div
        class="book-export__popup-content popup__content"
        @click="$event.stopPropagation()"
      >
        <div class="popup__close">
          <button @click="$emit('toggleShow')">
            <span class="popup__close-icon iconfont iclose-thin"></span>
          </button>
        </div>
        <div>
          <h2 class="popup__title book-export__popup-title">
            Kindle settings integration
          </h2>
          <div class="book-export__image-wrapper">
            <img
              class="book-export__settings-screenshot"
              src="@/assets.app/images/kindle-settings-desktop.png"
            />
          </div>
          <div class="book-export__image-wrapper">
            <img
              class="book-export__settings-screenshot-mobile"
              src="@/assets.app/images/kindle-settings-mobile.png"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  show: boolean
}>()

defineEmits<{
  (e: 'toggleShow'): void
}>()
</script>
